import { Route } from 'react-router-dom'
import { URLS } from './constants'
import { PrivateRoute } from 'components/utils/PrivateRoute'
import { Employees } from './Employees'
import { Employee } from './Employee'

export const useEmployeeRoutes = applicationPages => {
  return (
    <>
      <Route
        path={URLS.AUTH_EMPLOYEE_MANAGEMENT}
        element={<PrivateRoute component={Employees} applicationPages={applicationPages} />}
      />
      <Route
        path={URLS.AUTH_EMPLOYEE_MANAGEMENT_DETAILS}
        element={<PrivateRoute component={Employee} applicationPages={applicationPages} />}
      />
    </>
  )
}
